export const communityCasteRequestedColumns = [
	{
		label: 'Requested Date',
		render: r => (r?.createdAt ? new Date(r.createdAt).toLocaleDateString('en-IN') : ''),
	},
	{
		label: 'User Name',
		render: r => `${r?.user?.firstName || ''} ${r?.user?.lastName || ''}`,
	},
	{
		label: 'Mobile',
		render: r => r?.user?.mobile || '',
	},
	{
		label: 'Caste',
		render: r => r?.caste || '',
	},
	{
		label: 'Language',
		render: r => r?.language || '',
	},
	{
		label: 'Native Place',
		render: r => r?.nativeplace || '',
	},
	{
		label: 'Religion',
		render: r => r?.religion || '',
	},
	{
		label: 'Note',
		render: r => r?.significance || '',
	},
	{
		label: 'Requested Community',
		render: r => r?.otherCommunityName || '',
	},
	{
		label: 'Status',
		render: r => r?.status || '',
	},
]

export const switchCommunityRequestedColumns = [
	{
		label: 'Requested Date',
		render: r => (r?.createdAt ? new Date(r.createdAt).toLocaleDateString('en-IN') : ''),
	},
	{
		label: 'User Name',
		render: r => `${r?.user?.firstName || ''} ${r?.user?.lastName || ''}`,
	},
	{
		label: 'Mobile',
		render: r => r?.user?.mobile || '',
	},
	{
		label: 'Current Community',
		render: r => r?.hub?.name || '',
	},
	{
		label: 'New Community',
		render: r => r?.newHub?.name || '',
	},
	{
		label: 'Note',
		render: r => r?.significance || '',
	},
	{
		label: 'Status',
		render: r => r?.status || '',
	},
	{
		label: 'Resolve Date',
		render: r => (r?.resolveDate ? new Date(r.resolveDate).toLocaleDateString('en-IN') : ''),
	},
]
